export default __webpack_public_path__ + "static/media/phone.431eea2d.svg";